import fetcher from '../fetcher'

import config from '../../config'
import { Industry } from './types'
import { IResponseBody } from '../types'

export const getAllIndustries = async (): Promise<Array<Industry> | undefined> => {
	try {
		const res: IResponseBody<Array<Industry>> = await fetcher(`${config.VITE_ZRIVE_API_URL}/api/industries`, {
			method: 'GET'
		})
		return res.data
	} catch (error: unknown) {
    console.error(`Error fetching industries: ${error}`)
		throw error
	}
}
